import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CustomButtonProps } from "../../interfaces/Common";

// Custom styled components using props
export const AppButton = styled(Button)<CustomButtonProps>(({ theme, others, background }) => {
  return {
    textTransform: "capitalize",
    boxShadow: "none !important",
    background: background,
    color: others?.color || theme.palette.KenColors.kenWhite,
    "&:hover": {
      background: background,
      color: others?.color || theme.palette.KenColors.kenWhite,
    },
    ...others,
  };
});
